import React from "react"
import { Breadcrumbs, BreadcrumbItem } from "buoy-breadcrumbs"
import { pushRoute } from "../../common/route"
import breadcrumbConfig from "./breadcrumbConfig"
import { PAY_LINKS } from "../constants"
import { responsive } from "../../common/styledHelpers"

// KAN-4851 revisit

const getPath = () => {
  return `${window.location.pathname}/`
}

const isActive = crumb => {
  return getPath().includes(crumb.action)
}

const canClick = crumb => {
  return (
    getPath().includes(`${PAY_LINKS.payment}`) &&
    crumb.action === `${PAY_LINKS.account}`
  )
}

const Crumb = ({ crumb }) => (
  <BreadcrumbItem
    key={crumb.title}
    onClick={canClick(crumb) ? () => pushRoute(crumb.action, true) : null}
    active={isActive(crumb)}
  >
    {crumb.title}
  </BreadcrumbItem>
)

const BreadcrumbNav = () => {
  return (
    <Breadcrumbs margin={`${responsive("margin-bottom", "64px", "24px")}`}>
      {breadcrumbConfig.map(crumb => {
        return <Crumb crumb={crumb} />
      })}
    </Breadcrumbs>
  )
}

export { BreadcrumbNav as default }



// WEBPACK FOOTER //
// ./assets/payment/components/BreadcrumbNav.js